/** Мутация запроса кода для сброса пароля. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { authKeys } from "./keys";

export const useRequestPasswordReset = () => {
	const mutation = useMutation({
		mutationFn: Api.Auth.postApiAuthPasswordResetRequest,
		mutationKey: authKeys.requestPasswordReset,
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
